import React, { useState } from "react";
import PackageModel from "../PackageModel";
import { MdAdd } from "react-icons/md";
import BoltButton from "../../../../../../../Components/UI/Buttons/BoltButton";
import { setdata } from "../../../../../../../helpers/helpers";
import PackageGridView from "./PackageGridView";
import PackageListView from "./PackageListView";
import { LibraryFrame, useLibraryView } from "../Products/LibraryFrame";
import { showSnackBar } from "../../../../../../../store/common/snackBarSlice";
import { useDispatch } from "react-redux";

export default function PackagesScroller(props) {
  const {
    Plist,
    SetPlist,
    StepCheck,
    SetStepCheck,
    packageRefresh,
    setpackageRefresh,
    view,
    setView,
  } = props;
  const dispatch = useDispatch();


  const handlescrollpackage = (data) => {
    dispatch(
      showSnackBar({
        text: `${data?.name ?? "Package"} Added Successfully`,
        severity: "success",
      })
    );
    const x = Plist.length - 1;
    if (
      Plist[x]["name"] === "" &&
      Plist[x]["length"] === "" &&
      Plist[x]["width"] === "" &&
      Plist[x]["height"] === "" &&
      Plist[x]["weight"] === "" &&
      Plist[x]["description"] === "" &&
      Plist[x]["insurance"] === ""
    ) {
      // A new row object with the same keys in the same order (the request
      // bodies are byte-identical). Writing into the empty row itself changed
      // the shared row it can be (Ship.jsx's first row, or PackageList's
      // initialPackageRow after the single-row trash), so the package came
      // back on the next visit, after Ship More and in Add new row
      // (KNOWN_ISSUES SP-029, fixed 2026-10-20).
      const plist = [...Plist];
      plist[x] = {
        ...plist[x],
        name: data.name,
        length: setdata(() => data.length, false, ""),
        width: setdata(() => data.width, false, ""),
        height: setdata(() => data.height, false, ""),
        weight: setdata(() => data.weight, false, ""),
        volume: (
          (setdata(() => data.length, false, 0) *
            setdata(() => data.width, false, 0) *
            setdata(() => data.height, false, 0)) /
          1000000
        ).toFixed(2),
        description: data.description,
        insurance: "",
      };
      SetPlist(plist);
    } else {
      SetPlist([
        ...Plist,
        {
          name: data.name,
          length: setdata(() => data.length, false, ""),
          width: setdata(() => data.width, false, ""),
          height: setdata(() => data.height, false, ""),
          weight: setdata(() => data.weight, false, ""),
          description: data.description,
          insurance: "",
          volume: (
            (setdata(() => data.length, false, 0) *
              setdata(() => data.width, false, 0) *
              setdata(() => data.height, false, 0)) /
            1000000
          ).toFixed(2),
        },
      ]);
    }
    SetStepCheck((prevStepCheck) => ({
      ...prevStepCheck,
      Packages_bit: 0,
      QuoteCheck: false,
    }));
  };

  const [show, setshow] = useState(false);
  const handleshow = () => {
    setshow(!show);
  };

  const library = useLibraryView(view, setView);

  return (
    <>
      <LibraryFrame
        view={view}
        library={library}
        StepCheck={StepCheck}
        SetStepCheck={SetStepCheck}
        lead={
          <BoltButton
            type="button"
            icon={MdAdd}
            label="Add Package"
            onClick={handleshow}
            variant="primary"
            size="sm"
            className="myprod__add"
          />
        }
        barClass="packages__scroller_wrap_main_container"
        grid={
          <PackageGridView
            handlescrollpackage={handlescrollpackage}
            setFilter={library.setFilter}
            refresh={packageRefresh}
          />
        }
        list={(actions) => (
          <PackageListView
            handlescrollpackage={handlescrollpackage}
            refresh={packageRefresh}
            headerButtons={actions}
          />
        )}
      />
      <PackageModel
        Show={show}
        Handler={handleshow}
        setpackageRefresh={setpackageRefresh}
      />
    </>
  );
}
